<div class="page-signin" style="padding-top: 20vh">
  <div class="signin-body">
    <div class="container">
      <ng-content></ng-content>
    </div>
  </div>
</div>
